import { HeaderContextProvider } from '@lingoda/contexts';
import { TrackingContext } from '@lingoda/ui';
import type { PropsWithChildren } from 'react';

interface MainContextsProps {
    section: string;
}

export const MainContexts = ({ children, section }: PropsWithChildren<MainContextsProps>) => {
    return (
        <TrackingContext section={section}>
            <HeaderContextProvider>{children}</HeaderContextProvider>
        </TrackingContext>
    );
};
